<template>
  <div class="position-absolute p-10px left-container" :style="{ top: top, height: height }">
    <el-row
      type="flex"
      align="middle"
      class="card-title text-hex-fff text-24px h-52px w-full bg-no-repeat flex items-center pt-10px px-10px"
    >
      <el-col :span="18" class="fz-14 m-b-5px">偏好设置</el-col>
      <el-col :span="1" :offset="5">
        <span class="iconfont icon-line-close" @click="closeComponents"></span>
      </el-col>
    </el-row>
    <div class="h-full  my-20px overflow-hidden">
      <el-tabs
        v-model="activeName"
        class="h-[calc(100%-110px)] common-tab"
        @tab-click="settingActiveChange"
      >
        <el-tab-pane label="显示设置" name="displaySetting">
          <el-card
            class="w-full mb-10px"
            :body-style="{ width: '100%', height: '100%', padding: '5px 10px' }"
          >
            <SmallMap :player="player" :settingEnd="settingEnd"></SmallMap>
          </el-card>
          <el-card class="w-full mb-10px" :body-style="{ width: '100%', padding: '10px' }">
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">点选高亮</div>
              </el-col>
              <el-col :span="4" class="flex items-center">
                <el-switch
                  v-model="pickupHighlight"
                  @change="(e) => switchChange(e, 'pickUp.highlight')"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-col>
              <el-col :span="12" class="flex items-center">
                <el-color-picker
                  v-model="pickupHighlightColor"
                  size="small"
                  @change="
                    (e) => {
                      colorPickerChange(e, 'pickup.color', false, 'string')
                    }
                  "
                  show-alpha
                  color-format="rgb"
                ></el-color-picker>
                <el-input
                  v-model="pickupHighlightColor"
                  @change="
                    (e) => {
                      colorPickerChange(e, 'pickup.color', false, 'string')
                    }
                  "
                  placeholder=""
                  size="mini"
                ></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">包围盒</div>
              </el-col>
              <el-col :span="4" class="flex items-center">
                <el-switch
                  v-model="showSiegeBox"
                  @change="(e) => switchChange(e, 'show.select.box')"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-col>
              <el-col :span="12" class="flex items-center"></el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">点选轮廓</div>
              </el-col>
              <el-col :span="4" class="flex items-center">
                <el-switch
                  @change="(e) => switchChange(e, 'postprocess.outline')"
                  v-model="showPickupOutline"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-col>
              <el-col :span="12" class="flex items-center">
                <el-color-picker
                  v-model="pickupOutlineColor"
                  size="small"
                  show-alpha
                  @change="
                    (e) => {
                      colorPickerChange(e, 'pickup.edgeColor', true, 'string')
                    }
                  "
                  color-format="rgb"
                ></el-color-picker>
                <el-input
                  v-model="pickupOutlineColor"
                  placeholder=""
                  @change="
                    (e) => {
                      colorPickerChange(e, 'pickup.edgeColor', true, 'string')
                    }
                  "
                  size="mini"
                ></el-input>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">模型线框</div>
              </el-col>
              <el-col :span="4" class="flex items-center">
                <el-switch
                  @change="(e) => switchChange(e, 'render.edge')"
                  v-model="showModelBorder"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-col>
              <el-col :span="12" class="flex items-center"> </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle " class="p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">点选背景虚化</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="pickupBackgroundVirtual"
                  :min="0"
                  :max="1"
                  class="w-full"
                  :step="0.01"
                  @input="
                    (e) => {
                      sliderChange(e, 'color.pickup.bkAlpha', 'float')
                    }
                  "
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="pickupBackgroundVirtual"
                  placeholder=""
                  size="mini"
                  @change="
                    (e) => {
                      sliderChange(e, 'color.pickup.bkAlpha', 'float')
                    }
                  "
                  controls-position="right"
                  :min="0"
                  :max="1"
                  :step="0.01"
                ></el-input-number>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="w-full mb-10px" :body-style="{ width: '100%', padding: '10px' }">
            <el-row :gutter="8" type="flex" class="p-5px" align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">旋转速度</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="minimumRotateSpeed"
                  :min="0"
                  :max="1"
                  class="w-full"
                  :step="0.01"
                  @input="
                    (e) => {
                      sliderChange(e, 'mouse.rotate.speed', 'float')
                    }
                  "
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="minimumRotateSpeed"
                  placeholder=""
                  size="mini"
                  controls-position="right"
                  :min="0"
                  :max="1"
                  :step="0.01"
                  @change="
                    (e) => {
                      sliderChange(e, 'mouse.rotate.speed', 'float')
                    }
                  "
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" class="p-5px" align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">缩放速度</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="minimumScaleSpeed"
                  :min="0"
                  :max="1"
                  class="w-full"
                  :step="0.01"
                  @input="
                    (e) => {
                      sliderChange(e, 'mouse.scale.speed', 'float')
                    }
                  "
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="minimumScaleSpeed"
                  placeholder=""
                  size="mini"
                  controls-position="right"
                  :min="0"
                  :max="1"
                  :step="0.01"
                  @change="
                    (e) => {
                      sliderChange(e, 'mouse.scale.speed', 'float')
                    }
                  "
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" class="p-5px" align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">最小可见像素</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="minimumVisiblePixel"
                  :min="1"
                  :max="100"
                  class="w-full"
                  :step="1"
                  @input="
                    (e) => {
                      sliderChange(e, 'MinPixelCount', 'int')
                    }
                  "
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="minimumVisiblePixel"
                  placeholder=""
                  size="mini"
                  controls-position="right"
                  :min="1"
                  :max="100"
                  :step="1"
                  @change="
                    (e) => {
                      sliderChange(e, 'MinPixelCount', 'int')
                    }
                  "
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">环境光阻挡</div>
              </el-col>
              <el-col :span="4" class="flex items-center">
                <el-switch
                  @change="(e) => switchChange(e, 'postprocess.ssao')"
                  v-model="ambientLightBlock"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                ></el-switch>
              </el-col>
              <el-col :span="12" class="flex items-center"> </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class=" p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">全局光源</div>
              </el-col>
              <el-col :span="16" class="flex items-center">
                <el-select
                  v-model="globalLightSource"
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="mini"
                  placeholder="--请选择--"
                  @change="
                    (e) => {
                      selectChange(e, 'context.shaderIndex', 'int')
                    }
                  "
                >
                  <el-option
                    v-for="item in globalLightSourceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" class="p-5px " align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">环境光补偿</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="ambientLightRestitution"
                  :min="0"
                  :max="1"
                  class="w-full"
                  :step="0.01"
                  @input="
                    (e) => {
                      sliderChange(e, 'ambientIndenty', 'float')
                    }
                  "
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="ambientLightRestitution"
                  placeholder=""
                  size="mini"
                  @change="
                    (e) => {
                      sliderChange(e, 'ambientIndenty', 'float')
                    }
                  "
                  controls-position="right"
                  :min="0"
                  :max="1"
                  :step="0.01"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" class="p-5px" align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">全局光源强度</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="globalLightSourceStrength"
                  :min="0"
                  :max="1"
                  class="w-full"
                  @input="
                    (e) => {
                      sliderChange(e, 'diffuseIntensity', 'float')
                    }
                  "
                  :step="0.01"
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="globalLightSourceStrength"
                  placeholder=""
                  size="mini"
                  controls-position="right"
                  @input="
                    (e) => {
                      sliderChange(e, 'diffuseIntensity', 'float')
                    }
                  "
                  :min="0"
                  :max="1"
                  :step="0.01"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" class="p-5px" align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">高光强度</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="highLightStrength"
                  :min="0"
                  :max="1.5"
                  class="w-full"
                  @input="
                    (e) => {
                      sliderChange(e, 'specularIntensity', 'float')
                    }
                  "
                  :step="0.01"
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="highLightStrength"
                  placeholder=""
                  size="mini"
                  controls-position="right"
                  @input="
                    (e) => {
                      sliderChange(e, 'specularIntensity', 'float')
                    }
                  "
                  :min="0"
                  :max="1.5"
                  :step="0.01"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" class="p-5px" align="middle">
              <el-col :span="8">
                <div class="w-full text-white text-12px">相机最小裁剪面</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="minimumCuttingSurface"
                  :min="0"
                  :max="1"
                  class="w-full"
                  @input="
                    (e) => {
                      sliderChange(e, 'camera.minClip', 'float')
                    }
                  "
                  :step="0.001"
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="minimumCuttingSurface"
                  placeholder=""
                  size="mini"
                  controls-position="right"
                  @change="
                    (e) => {
                      sliderChange(e, 'camera.minClip', 'float')
                    }
                  "
                  :min="0"
                  :max="1"
                  :step="0.001"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class=" p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">背面裁剪</div>
              </el-col>
              <el-col :span="16" class="flex items-center">
                <el-select
                  v-model="backCutting"
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="mini"
                  placeholder="--请选择--"
                  @change="
                    (e) => {
                      selectChange(e, 'cullface_mode', 'stringList')
                    }
                  "
                >
                  <el-option
                    v-for="item in backCuttingOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="p-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">天空盒</div>
              </el-col>
              <el-col :span="16" class="flex items-center">
                <el-select
                  v-model="skyBox"
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="mini"
                  placeholder="--请选择--"
                  @change="
                    (e) => {
                      selectChange(e, 'skybox.list', 'stringList')
                    }
                  "
                >
                  <el-option
                    v-for="item in skyBoxOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="p-5px" v-if="skyBox === 'null'">
              <el-col :span="8">
                <div class="w-full text-white text-12px">选择颜色</div>
              </el-col>
              <el-col :span="16" class="flex items-center">
                <el-color-picker
                  v-model="bgColor"
                  size="small"
                  @change="
                    (e) => {
                      colorPickerChange(e, 'bg.color', false, 'string')
                    }
                  "
                  show-alpha
                  color-format="rgb"
                ></el-color-picker>
              </el-col>
            </el-row>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="漫游设置" name="roamingSetting">
          <el-card class="w-full mb-10px" :body-style="{ width: '100%', padding: '5px 10px' }">
            <div class="w-full font-bold text-14px mt-10px text-white">虚拟人物形象</div>
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">人物安全帽</div>
              </el-col>
              <el-col :span="16" class="flex items-center">
                <el-select
                  v-model="safetyHelmet"
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="mini"
                  placeholder="--请选择--"
                  @change="(e) => changeFigureMolding(e, 'setAvatarCapSkin')"
                >
                  <el-option
                    v-for="item in safetyHelmetOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    class="flex items-center"
                  >
                    <div
                      class="h-15px w-15px ml-10px"
                      :style="{ backgroundColor: item.color }"
                    ></div>
                    <span class="ml-10px">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">人物工作服</div>
              </el-col>
              <el-col :span="16" class="flex items-center">
                <el-select
                  v-model="workingClothes"
                  popper-class="visualization-select-popper"
                  class="w-full"
                  size="mini"
                  placeholder="--请选择--"
                  @change="(e) => changeFigureMolding(e, 'setAvatarBodySkin')"
                >
                  <el-option
                    v-for="item in workingClothesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    class="flex items-center"
                  >
                    <div
                      class="h-15px w-15px ml-10px"
                      :style="{ backgroundColor: item.color }"
                    ></div>
                    <span class="ml-10px">{{ item.label }}</span>
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="w-full mb-10px" :body-style="{ width: '100%', padding: '10px' }">
            <el-row :gutter="8" type="flex" align="middle" class="mt-5px">
              <el-col :span="8">
                <div class="w-full text-white text-12px">人物移动速度</div>
              </el-col>
              <el-col :span="9" class="flex items-center">
                <el-slider
                  v-model="mouseMoveSpeed"
                  :min="1"
                  :max="10"
                  class="w-full"
                  :step="1"
                  @input="
                    (e) => {
                      changeWalkSpeed(e)
                    }
                  "
                ></el-slider>
              </el-col>
              <el-col :span="7" class="flex items-center">
                <el-input-number
                  v-model="mouseMoveSpeed"
                  placeholder=""
                  size="mini"
                  @change="
                    (e) => {
                      changeWalkSpeed(e)
                    }
                  "
                  controls-position="right"
                  :min="1"
                  :max="10"
                  :step="1"
                ></el-input-number>
              </el-col>
            </el-row>
          </el-card>
          <el-card class="w-full mt-5px h-480px" :body-style="{ width: '100%', padding: '10px' }">
            <div class="w-full font-bold text-14px mt-10px text-white">快捷键设置</div>
            <el-row :gutter="8" class="mt-5px">
              <el-col
                :span="12"
                class="flex items-center mt-10px"
                v-for="item in shortCutKeySettings"
                :key="item.name"
              >
                <div class="w-full text-white text-12px mr-5px">{{ item.label }}</div>
                <el-tooltip effect="dark" :content="item.value" placement="top" :open-delay="1000">
                  <el-input
                    :value="item.value"
                    @focus="
                      (e) => {
                        keySetting(e, item, 1)
                      }
                    "
                    placeholder=""
                    size="mini"
                  ></el-input>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <div class="w-full flex items-center justify-end">
        <el-button size="mini" @click="restoreDefault" :loading="savaLoading"
          >恢复默认设置</el-button
        >
        <!-- <el-button size="mini" @click="closeComponents" :loading="savaLoading">取消</el-button> -->
        <el-button type="primary" size="mini" @click="saveSettings" :loading="savaLoading"
          >保存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { PreferenceSettingApi } from '@/services/cloud-render-management'

import cloudRender from '../js/model/index'
import SmallMap from './smallMap'

export default {
  name: 'PreferenceSetting',
  components: { SmallMap },
  props: {
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    height: {
      type: String,
      default: '58rem',
    },
    top: {
      type: String,
      default: '6.6rem',
    },
  },
  data() {
    return {
      bgColor: 'rgba(255,255,255,1)', // 背景颜色
      defaultSettings: {}, // 默认设置
      savaLoading: false, // 保存时loading
      activeName: 'displaySetting',
      pickupHighlight: true, // 点选高亮
      pickupHighlightColor: 'rgba(255,255,255,1)', // 点选高亮颜色
      showSiegeBox: true, // 包围盒
      showPickupOutline: true, // 点选轮廓
      pickupOutlineColor: 'rgba(255,255,255,1)', // 点选轮廓颜色
      showModelBorder: true, // 模型线框
      pickupBackgroundVirtual: 0, // 点选背景虚化
      mouseMoveSpeed: 1, // 人物移动速度
      ambientLightBlock: true, // 环境光阻挡
      ambientLightRestitution: 0, // 环境光补偿
      globalLightSource: '', // 全局光源
      // 全局光源配置
      globalLightSourceOptions: [
        { value: 0, label: '默认' },
        { value: 1, label: '预设单灯' },
        { value: 2, label: '预设双灯' },
        { value: 3, label: '预设三灯' },
      ],
      globalLightSourceStrength: 0, // 全局光源强度
      minimumCuttingSurface: 0, // 摄像机最小裁剪面
      highLightStrength: 0, // 高光强度
      minimumVisiblePixel: 0, // 最小可见像素
      minimumRotateSpeed: 0, // 旋转速度
      minimumScaleSpeed: 0, // 缩放速度
      skyBox: '', // 天空盒
      skyBoxOptions: [],
      anchorPointInfoFrame: '', // 锚点信息框
      anchorPointInfoFrameOptions: [
        { value: 'null', label: '无' },
        { value: 'code', label: '对象编码' },
        { value: 'name', label: '对象名称' },
        { value: 'code+name', label: '编码+名称' },
      ],
      safetyHelmet: '', // 人物安全帽
      safetyHelmetOptions: [
        { value: 'yellow', label: '黄色', color: '#ffff00' },
        { value: 'blue', label: '蓝色', color: '#0000ff' },
        { value: 'white', label: '白色', color: '#ffffff' },
        { value: 'orange', label: '橙色', color: '#ffa500' },
        { value: 'red', label: '红色', color: '#ff0000' },
      ],
      backCutting: '', // 背面裁剪
      backCuttingOptions: [
        { value: 'none', label: '未设置' },
        { value: 'front', label: '显示正面' },
        { value: 'back', label: '显示背面' },
        { value: 'frontAndBack', label: '双面绘制' },
      ],
      workingClothes: '', // 人物工作服
      workingClothesOptions: [
        { value: 'red', label: '红色', color: '#ff0000' },
        { value: 'white', label: '白色', color: '#ffffff' },
        { value: 'yellow', label: '黄色', color: '#ffff00' },
        { value: 'blue', label: '蓝色', color: '#0000ff' },
        { value: 'gray', label: '浅灰色', color: '#dcdfe6' },
      ],
      roamingAngle: 'firstAngle', // 漫游视角
      shortCutKeySettings: [
        {
          label: '前进',
          name: '前进',
          value: 'W',
        },
        {
          label: '后退',
          name: '后退',
          value: 'S',
        },
        {
          label: '向左移动',
          name: '向左移动',
          value: 'A',
        },
        {
          label: '向右移动',
          name: '向右移动',
          value: 'D',
        },
        {
          label: '向上仰视',
          name: '向上仰视',
          value: 'I',
        },
        {
          label: '向下俯视',
          name: '向下俯视',
          value: 'K',
        },
        {
          label: '左转',
          name: '左转',
          value: 'J',
        },
        {
          label: '右转',
          name: '右转',
          value: 'L',
        },
        {
          label: '跳起',
          name: '跳起',
          value: 'Space',
        },
        {
          label: '无重力跳',
          name: '无重力跳',
          value: 'Z+Space',
        },
        {
          label: '奔跑',
          name: '奔跑',
          value: 'Shift',
        },
        {
          label: '蹲下',
          name: '蹲下',
          value: 'Ctrl',
        },
        {
          label: '垂直向上',
          name: '垂直向上移动',
          value: 'Q',
        },
        {
          label: '垂直向下',
          name: '垂直向下移动',
          value: 'E',
        },
        {
          label: '穿墙',
          name: '开启/关闭人物穿墙',
          value: 'C',
        },
        {
          label: '开/关失重',
          name: '开启/关闭人物飞行模式',
          value: 'Comma',
        },
        // {
        //   label: '增加速度',
        //   name: '增加漫游前进速度',
        //   value: '+',
        // },
        // {
        //   label: '减少速度',
        //   name: '减少漫游前进速度',
        //   value: '-',
        // },
      ],
      walkingSpeed: 0, // 行走速度
      squatMoveSpeed: 0, // 蹲下移动速度
      runSpeed: 0, // 奔跑速度
      sliderChangeTimerOut: null, // 滑动条防抖
      orignPlayerSettings: [], // 初始设置
      orignHotKeysSettings: {}, // 初始漫游设置
      orignFigureSettings: {}, // 初始人物形象
      settingEnd: false,
      settingAllOptions: [
        // 背景颜色
        { name: 'bg.color', type: 'string', value: '' },
        // 旋转速度
        { name: 'mouse.rotate.speed', type: 'float', value: '' },
        // 缩放速度
        { name: 'mouse.scale.speed', type: 'float', value: '' },
        // 锚点信息框
        { name: 'anchorPointInfoFrame', type: 'string', value: '' },
        // 点选高亮
        { name: 'pickUp.highlight', type: 'bool', value: '' },
        // 点选高亮颜色
        { name: 'pickup.color', type: 'string', value: '' },
        // 显示包围盒
        { name: 'show.select.box', type: 'bool', value: '' },
        // 点选轮廓
        { name: 'postprocess.outline', type: 'bool', value: '' },
        // 点选轮廓颜色
        { name: 'pickup.edgeColor', type: 'string', value: '' },
        // 模型线框
        { name: 'render.edge', type: 'bool', value: '' },
        // 点选背景虚化
        { name: 'color.pickup.bkAlpha', type: 'float', value: '' },
        // 摄像机最小裁剪面
        { name: 'MinPixelCount', type: 'int', value: '' },
        // 环境光阻挡
        { name: 'postprocess.ssao', type: 'bool', value: '' },
        // 点选高亮
        { name: 'postprocess', type: 'bool', value: '' },
        // 环境光补偿
        { name: 'ambientIndenty', type: 'float', value: '' },
        // 全局光源
        { name: 'context.shaderIndex', type: 'int', value: '' },
        // 全局光源强度
        { name: 'diffuseIntensity', type: 'float', value: '' },
        // 高光强度
        { name: 'specularIntensity', type: 'float', value: '' },
        // 摄像机最小裁剪面
        { name: 'camera.minClip', type: 'float', value: '' },
        // 绘制天空
        { name: 'shader.sky', type: 'bool', value: true },
        // 天空盒
        { name: 'skybox.list', type: 'stringList', value: '' },
        // 背面裁剪
        { name: 'cullface_mode', type: 'stringList', value: '' },
        // 地图设置
        { name: 'panorama.show', type: 'bool', value: '' },
        { name: 'map.pos', type: 'stringList', value: '' },
        { name: 'map.dir', type: 'stringList', value: '' },
        { name: 'map.size.x', type: 'int', value: '' },
        { name: 'map.size.y', type: 'int', value: '' },
        { name: 'map.scale.x', type: 'double', value: '' },
        { name: 'map.scale.y', type: 'double', value: '' },
      ],
      isConfirmClose: false,
    }
  },
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async created() {
    const settingsFileUrl = `data://../apps/${this.modelSetting.folderName}/settings.json`
    const settingsData = await cloudRender.Setting.getSettingData(this.player, settingsFileUrl)
    if (settingsData && settingsData.status && settingsData.data) {
      this.defaultSettings = JSON.parse(settingsData.data)
    } else {
      const defaultSettings = await cloudRender.Setting.getAll(this.player)
      this.defaultSettings.Show = _.filter(defaultSettings.data || [], (item) => {
        return (
          _.findIndex(this.settingAllOptions, (el) => {
            return el.name === item.name && el.type === item.type
          }) !== -1
        )
      })
      const defaultHotKeys = await cloudRender.Walking.getAllHotKey(this.player)
      this.defaultSettings.RoamTrance = _.reduce(
        defaultHotKeys.data || [],
        (obj, item) => {
          obj[item.label] = item.code
          return obj
        },
        {}
      )
      const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
      this.defaultSettings.RoamTrance.RoamingSpeed = speedData.data
      this.defaultSettings.People = {
        avatarCapSkin: 'white',
        avatarBodySkin: 'red',
      }
    }
    this.getAllSetting()
  },
  beforeDestroy() {
    document.oncontextmenu = null
    document.onkeydown = null
    this.closeComponents()
  },
  methods: {
    // 恢复默认设置
    async restoreDefault() {
      this.$confirm('是否恢复默认设置！', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      }).then(async () => {
        cloudRender.Setting.set(this.player, this.defaultSettings.Show)
        _.forIn(this.defaultSettings.RoamTrance, (value, key) => {
          const settingKeys = value[0] || []
          cloudRender.Walking.setHotKeys(this.player, { name: key, code: settingKeys })
        })
        cloudRender.Walking.setAvatarSpeed(
          this.player,
          this.defaultSettings.RoamTrance.RoamingSpeed
        )
        const skinObj = {
          body: this.defaultSettings.People.avatarBodySkin,
          head: this.defaultSettings.People.avatarCapSkin,
        }
        cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skinObj)

        this.savaLoading = true
        // 组装接口参数
        const filterDisplaySettings = _.filter(this.defaultSettings.Show, (item) => {
          return _.findIndex(this.settingAllOptions, ['name', item.name]) !== -1
        })
        const displayParams = _.reduce(
          filterDisplaySettings,
          (obj, item) => {
            obj[item.name] = item.value
            return obj
          },
          {}
        )
        // 获取当前漫游设置
        const hotKeysData = await cloudRender.Walking.getAllHotKey(this.player)
        const currentRoamingSettings = _.reduce(
          hotKeysData.data || [],
          (obj, item) => {
            obj[item.label] = item.code
            return obj
          },
          {}
        )
        // 组装接口参数
        _.forIn(currentRoamingSettings, (value, key) => {
          currentRoamingSettings[key] = JSON.stringify(value)
        })
        const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
        currentRoamingSettings.RoamingSpeed = String(speedData.data)
        // 保存设置
        const res = await PreferenceSettingApi.create({
          extraProperties: {
            Show: displayParams,
            RoamTrance: currentRoamingSettings,
            People: this.defaultSettings.People,
          },
        })
        this.savaLoading = false
        if (!err && res) {
          const displaySettings = _.reduce(
            filterDisplaySettings,
            (obj, item) => {
              obj[item.name] = item.value
              return obj
            },
            {}
          )
          this.orignPlayerSettings = displaySettings
          this.orignHotKeysSettings = this.defaultSettings.RoamTrance
          this.$message.success('恢复默认设置成功！')
          this.getAllSetting()
        } else {
          this.$message.warning('设置失败！')
        }
      })
    },
    // 保存设置
    async saveSettings() {
      this.$confirm('是否保存当前设置！', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        type: 'warning',
        lockScroll: false,
      })
        .then(async () => {
          this.savaLoading = true
          // 获取当前player显示设置
          const settingData = await cloudRender.Setting.getAll(this.player)
          const currentDisplaySettings = settingData.data || []
          const filterDisplaySettings = _.filter(currentDisplaySettings, (item) => {
            return _.findIndex(this.settingAllOptions, ['name', item.name]) !== -1
          })
          // 组装接口参数
          const displayParams = _.reduce(
            filterDisplaySettings,
            (obj, item) => {
              obj[item.name] = item.value
              return obj
            },
            {}
          )
          // 获取当前漫游设置
          const hotKeysData = await cloudRender.Walking.getAllHotKey(this.player)
          const currentRoamingSettings = _.reduce(
            hotKeysData.data || [],
            (obj, item) => {
              obj[item.label] = item.code
              return obj
            },
            {}
          )

          // 组装接口参数
          _.forIn(currentRoamingSettings, (value, key) => {
            currentRoamingSettings[key] = JSON.stringify(value)
          })
          const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
          currentRoamingSettings.RoamingSpeed = speedData.data
          // 人物形象设置
          const skinParams = {
            avatarCapSkin: this.safetyHelmet,
            avatarBodySkin: this.workingClothes,
          }
          // 保存设置
          const res = await PreferenceSettingApi.create({
            extraProperties: {
              Show: displayParams,
              RoamTrance: currentRoamingSettings,
              People: skinParams,
            },
          })
          this.savaLoading = false
          if (res) {
            this.isConfirmClose = true
            this.$emit('closeComponents', 'PreferenceSetting')
            this.$message.success('保存设置成功！')
          } else {
            this.isConfirmClose = true
            this.$emit('closeComponents', 'PreferenceSetting')
            this.$message.warning('保存设置失败！')
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    // 关闭设置
    async closeComponents() {
      if (this.isConfirmClose) {
        return this.$emit('closeComponents', 'PreferenceSetting')
      }
      // 获取当前player显示设置
      const settingData = await cloudRender.Setting.getAll(this.player)
      const currentDisplaySettings = settingData.data || []
      const filterCurrentDisplaySettings = _.filter(currentDisplaySettings, (item) => {
        return _.findIndex(this.settingAllOptions, ['name', item.name]) !== -1
      })
      const filterEffectSettings = _.filter(filterCurrentDisplaySettings, (item) => {
        return _.find(this.settingAllOptions, (el) => {
          return el.name === item.name && el.type === item.type
        })
      })
      console.log('isConfirmse----------')

      // 是否有更新过设置
      const isUpdateDisplay = _.every(filterEffectSettings, (item) => {
        let originItem = ''
        if (item.type === 'bool') {
          originItem =
            this.orignPlayerSettings[item.name] === 'true' ||
            this.orignPlayerSettings[item.name] === true
        } else if (item.type === 'int' || item.type === 'float' || item.type === 'double') {
          originItem = _.toNumber(this.orignPlayerSettings[item.name])
        } else {
          originItem = this.orignPlayerSettings[item.name]
        }
        return _.isNil(originItem) || item.name === 'shadow.bias' ? true : item.value === originItem
      })
      // 获取当前漫游按键设置
      const hotKeysData = await cloudRender.Walking.getAllHotKey(this.player)
      const currentRoamingSettings = _.reduce(
        hotKeysData.data || [],
        (obj, item) => {
          obj[item.label] = item.code
          return obj
        },
        {}
      )

      const currentKeys = Object.getOwnPropertyNames(currentRoamingSettings)
      // 判断是否有更新设置
      const isUpdateRoaming = _.every(currentKeys, (item) => {
        return (
          currentRoamingSettings[item][0] &&
          this.orignHotKeysSettings[item][0] &&
          _.isEmpty(
            _.difference(currentRoamingSettings[item][0], this.orignHotKeysSettings[item][0])
          )
        )
      })
      if (
        !isUpdateDisplay ||
        !isUpdateRoaming ||
        this.safetyHelmet !== this.orignFigureSettings.avatarCapSkin ||
        this.workingClothes !== this.orignFigureSettings.avatarBodySkin
      ) {
        this.$confirm('是否保存当前设置！', '提示', {
          confirmButtonText: '保存',
          cancelButtonText: '取消',
          type: 'warning',
          lockScroll: false,
        })
          .then(async () => {
            this.savaLoading = true
            const displayParams = _.reduce(
              filterCurrentDisplaySettings,
              (obj, item) => {
                obj[item.name] = item.value
                return obj
              },
              {}
            )
            _.forIn(currentRoamingSettings, (value, key) => {
              currentRoamingSettings[key] = JSON.stringify(value)
            })
            const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
            currentRoamingSettings.RoamingSpeed = speedData.data

            // 人物形象设置
            const skinParams = {
              avatarCapSkin: this.safetyHelmet,
              avatarBodySkin: this.workingClothes,
            }
            const res = await PreferenceSettingApi.create({
              extraProperties: {
                Show: displayParams,
                RoamTrance: currentRoamingSettings,
                People: skinParams,
              },
            })
            this.savaLoading = false
            if (res) {
              this.$message.success('保存设置成功！')
              this.isConfirmClose = true
              this.$emit('closeComponents', 'PreferenceSetting')
            } else {
              this.$message.warning('部分设置保存失败！')
              this.isConfirmClose = true
              this.$emit('closeComponents', 'PreferenceSetting')
            }
          })
          .catch(async (err) => {
            // 还原更新之前的设置
            _.forIn(this.orignPlayerSettings, (value, key) => {
              // 找到对应设置的值类型（int,float,double,bool,string）
              const settingInfo = _.find(currentDisplaySettings, ['name', key])
              if (settingInfo) {
                let currentValue = ''
                if (settingInfo.type === 'bool') {
                  currentValue = value === 'true' || value === true
                } else if (
                  settingInfo.type === 'int' ||
                  settingInfo.type === 'float' ||
                  settingInfo.type === 'double'
                ) {
                  currentValue = _.toNumber(value)
                } else {
                  currentValue = value
                }
                cloudRender.Setting.set(this.player, {
                  name: key,
                  type: settingInfo.type,
                  value: currentValue,
                })
              }
            })
            _.forIn(this.orignHotKeysSettings, (value, key) => {
              const settingKeys = value[0] || []
              cloudRender.Walking.setHotKeys(this.player, { name: key, code: settingKeys })
            })
            const skinObj = {
              body: this.orignFigureSettings.avatarBodySkin,
              head: this.orignFigureSettings.avatarCapSkin,
            }
            cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skinObj)
            this.isConfirmClose = true
            this.$emit('closeComponents', 'PreferenceSetting')
          })
      } else {
        this.isConfirmClose = true
        this.$emit('closeComponents', 'PreferenceSetting')
      }
    },
    // 切换设置内容
    settingActiveChange(e) {
      if (e.name === 'roamingSetting') {
        document.oncontextmenu = () => {
          return false
        }
        // eslint-disable-next-line no-shadow
        document.onkeydown = (e) => {
          e = window.event || e
          if (
            (e.keyCode >= 112 && e.keyCode <= 123) ||
            e.keyCode === 9 ||
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey
          ) {
            e.preventDefault()
            return false
          }
          return true
        }
      } else {
        document.oncontextmenu = null
        document.onkeydown = null
      }
    },
    // 获取所有设置
    async getAllSetting() {
      const res = await PreferenceSettingApi.getCurrentUserSetting()
      if (res) {
        const data = res?.extraProperties
        const jsonRes = await cloudRender.Setting.getSettingData(
          this.player,
          `data://../apps/${this.modelSetting.folderName}/settings.json`
        )
        const settingJsonData = jsonRes.data || ''
        let settingsData = {}
        let currentPlayerSettings = {}
        let currentRoamingSettings = {}
        let currentFigureSettings = {}
        if (settingJsonData) {
          settingsData = JSON.parse(settingJsonData)
        }
        if (settingsData.Show) {
          currentPlayerSettings = settingsData.Show
        } else {
          const settingData = await cloudRender.Setting.getAll(this.player)
          currentPlayerSettings = settingData.data || []
        }
        const hotKeysData = await cloudRender.Walking.getAllHotKey(this.player)
        if (settingsData.RoamTrance) {
          currentRoamingSettings = settingsData.RoamTrance
        } else {
          currentRoamingSettings = _.reduce(
            hotKeysData.data || [],
            (obj, item) => {
              obj[item.label] = item.code
              return obj
            },
            {}
          )
        }
        if (settingsData.People) {
          currentFigureSettings = settingsData.People
        } else {
          currentFigureSettings = {
            avatarCapSkin: 'white',
            avatarBodySkin: 'red',
          }
        }
        const displaySettings = _.reduce(
          currentPlayerSettings,
          (obj, item) => {
            obj[item.name] = item.value
            return obj
          },
          {}
        )
        this.orignPlayerSettings = _.isNil(data?.Show) ? displaySettings : data?.Show
        if (!_.isNil(data?.RoamTrance)) {
          const roamTrance = data?.RoamTrance
          _.forIn(roamTrance, (value, key) => {
            roamTrance[key] = JSON.parse(value)
          })
          this.orignHotKeysSettings = roamTrance
        } else {
          this.orignHotKeysSettings = currentRoamingSettings
        }
        this.orignFigureSettings = _.isNil(data?.People) ? currentFigureSettings : data?.People
        this.safetyHelmet = this.orignFigureSettings.avatarCapSkin
        this.workingClothes = this.orignFigureSettings.avatarBodySkin
        const playerSettings = _.cloneDeep(this.orignPlayerSettings)
        const roamingSettings = _.cloneDeep(this.orignHotKeysSettings)
        this.getDisplaySettings(playerSettings)
        this.getRoamingSettings(roamingSettings)
        this.settingEnd = true
      }
    },
    // 获取漫游设置
    async getRoamingSettings(data) {
      _.forEach(this.shortCutKeySettings, (item) => {
        const currentKey = data[item.name]
        if (currentKey && currentKey.length) {
          item.value = cloudRender.Walking.hotKeyMap[currentKey[0]]
        }
      })
      const speedData = await cloudRender.Walking.getAvatarSpeed(this.player)
      this.mouseMoveSpeed = speedData.data
    },
    // 获取显示设置
    async getDisplaySettings(data) {
      const skyBoxList = await cloudRender.Setting.get(this.player, 'skybox.list')
      const skyBox = skyBoxList.data && skyBoxList.data.length ? skyBoxList.data[0] : {}
      // 天空盒可选项
      this.skyBoxOptions = _.map(skyBox.dataSource, (item) => {
        return { value: item, label: item }
      })
      // 背景颜色
      this.bgColor = this.colorToRgba(data['bg.color'] || '1,0,0,1')
      // 点选高亮——pickUp.highlight——bool
      this.pickupHighlight = this.stringToBoolean(data['pickUp.highlight'])
      // 点选高亮颜色——pickup.color
      this.pickupHighlightColor = this.colorToRgba(data['pickup.color'])
      // 包围盒——show.select.box——bool
      this.showSiegeBox = this.stringToBoolean(data['show.select.box'])
      // 点选轮廓——postprocess.outline——bool
      this.showPickupOutline = this.stringToBoolean(data['postprocess.outline'])
      // 点选轮廓颜色——pickup.edgeColor
      this.pickupOutlineColor = this.colorToRgba(data['pickup.edgeColor'], true)
      // 模型线框——render.edge——bool
      this.showModelBorder = this.stringToBoolean(data['render.edge'])
      // 点选背景虚化——color.pickup.bkAlpha
      this.pickupBackgroundVirtual = _.round(data['color.pickup.bkAlpha'], 2)
      // 摄像机最小裁剪面——MinPixelCount
      this.minimumVisiblePixel = _.round(data.MinPixelCount, 2)
      // 旋转速度
      this.minimumRotateSpeed = _.round(data['mouse.rotate.speed'], 2)
      // 缩放速度
      this.minimumScaleSpeed = _.round(data['mouse.scale.speed'], 2)
      // 环境光阻挡——postprocess——bool
      this.ambientLightBlock = this.stringToBoolean(data['postprocess.ssao'])
      // 环境光补偿——ambientIndenty
      this.ambientLightRestitution = _.round(data.ambientIndenty, 2)
      // 全局光源——context.shaderIndex
      this.globalLightSource = _.toNumber(data['context.shaderIndex'])
      // 全局光源强度——diffuseIntensity
      this.globalLightSourceStrength = _.round(data.diffuseIntensity, 2)
      // 高光强度——specularIntensity
      this.highLightStrength = _.round(data.specularIntensity, 2)
      // 摄像机最小裁剪面——camera.minClip
      this.minimumCuttingSurface = _.round(data['camera.minClip'], 3)
      // 天空盒——skybox.select
      this.skyBox = data['skybox.list']
      // 背面裁剪——cullface_mode
      this.backCutting = data.cullface_mode
      // 锚点信息框——anchorPointInfoFrame
      this.anchorPointInfoFrame = data.anchorPointInfoFrame
    },
    // 字符串转Boolean
    stringToBoolean(value) {
      return value === 'true' || value === true
    },
    // 颜色转换
    colorToRgba(value, special = false) {
      const color = value.split(',')
      if (special) {
        return `rgba(${color[0] * 1},${color[1] * 1},${color[2] * 1},${color[3] / 255})`
      }
      return `rgba(${color[0] * 255},${color[1] * 255},${color[2] * 255},${color[3] / 1})`
    },
    // 漫游按键设置
    keySetting(e, item) {
      let currentKeys = []
      e.target.onkeydown = (event) => {
        const keyStatus = cloudRender.Walking.hotKeyMap[event.keyCode]
        if (!keyStatus) {
          this.$message.warning('按键无效，请重新输入！')
          return
        }
        if (!_.includes(currentKeys, keyStatus)) {
          currentKeys.push(keyStatus)
        }
        item.value = !_.isEmpty(currentKeys) ? currentKeys.join('+') : ''
      }
      e.target.onkeyup = async () => {
        e.srcElement.blur()
        const settingKeys = currentKeys
        if (!_.isEmpty(settingKeys)) {
          const currentSettingKeys = _.map(settingKeys, (el) => {
            return cloudRender.Walking.hotKeyMap[el]
          })
          if (!_.isEmpty(currentSettingKeys)) {
            const setRes = await cloudRender.Walking.setHotKeys(this.player, {
              name: item.name,
              code: currentSettingKeys,
            })
          }
        }
        currentKeys = []
      }
    },
    // switch状态改变时触发
    switchChange(e, val) {
      if ((val === 'postprocess.ssao' || val === 'postprocess.outline') && e) {
        cloudRender.Setting.set(this.player, { name: 'postprocess', type: 'bool', value: true })
      }
      cloudRender.Setting.set(this.player, { name: val, type: 'bool', value: e })
    },
    // 下拉框选择改变
    selectChange(e, val, type) {
      cloudRender.Setting.set(this.player, { name: val, type, value: e })
      if (val === 'skybox.list') {
        cloudRender.Setting.set(this.player, {
          name: 'shader.sky',
          type: 'bool',
          value: e !== 'null',
        })
      }
    },
    // 滑动条值改变触发
    sliderChange(e, val, type) {
      if (this.sliderChangeTimerOut) clearTimeout(this.sliderChangeTimerOut)
      this.sliderChangeTimerOut = setTimeout(() => {
        cloudRender.Setting.set(this.player, { name: val, type, value: e })
      }, 100)
    },
    // 人物移动速度发生变化时
    changeWalkSpeed(e) {
      cloudRender.Walking.setAvatarSpeed(this.player, e)
    },
    // 颜色选择器值改变
    colorPickerChange(e, val, special, type) {
      const rgbList = e.slice(5, -1).split(',')
      const rgb = _.map(rgbList, (item, index) => {
        let res = ''
        if (index !== rgbList.length - 1) {
          res = special ? _.toNumber(item) : _.round(_.toNumber(item) / 255, 2)
        } else {
          res = special ? item * 255 : _.toNumber(item)
        }
        return res
      })
      cloudRender.Setting.set(this.player, { name: val, type, value: rgb.join(',') })
    },
    // 更换人物形象
    async changeFigureMolding(e, name) {
      const skin = {
        body: '',
        head: '',
      }
      if (name === 'setAvatarBodySkin') {
        skin.body = e
      } else if (name === 'setAvatarCapSkin') {
        skin.head = e
      }
      cloudRender.Walking.setAvatarSkin(this.player, 'GongRen', skin)
    },
  },
}
</script>

<style lang="scss" scoped>

@import '../css/component.scss';

</style>
